import { VGDisclaimerContent } from '../../../../components/VGDisclaimerContent/VGDisclaimerContent';
import { FunctionComponent } from 'react';
import { useStatePageQuery } from '../../../graphql/useStatePageQuery';

export const StatePageVGDisclaimerModalContentWithData: FunctionComponent = () => {
  const vgDisclaimerHtml = useStatePageQuery()?.data?.statePageBySlug?.vgDisclaimerHtml;

  return <VGDisclaimerContent vgDisclaimerHtml={vgDisclaimerHtml ?? null} />;
};
